import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, ArrowUp } from "lucide-react";
import { NAV, SEDI, CONTACT } from "../data/site";

const SOCIAL = [
  { label: "Instagram", href: CONTACT.instagram, Icon: Instagram },
  { label: "Facebook", href: CONTACT.facebook, Icon: Facebook },
  { label: "LinkedIn", href: CONTACT.linkedin, Icon: Linkedin },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-[color:var(--ngp-ink)] text-white">
    <div className="mx-auto max-w-[1440px] px-5 pt-20 sm:px-8 lg:px-12">
      <div className="grid gap-12 border-b border-white/10 pb-16 md:grid-cols-2 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <img src="/img/logo-gigaprint-white.png" alt="Giga Print" width="572" height="180" loading="lazy" className="h-12 w-auto" />
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-white/70">Stampa, allestimenti, creatività e digital marketing per aziende che vogliono farsi notare.</p>
          <div className="mt-6 flex gap-2">
            {SOCIAL.map(({ label, href, Icon }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} data-testid={`footer-social-${label.toLowerCase()}`}
                className="grid h-11 w-11 place-items-center rounded-full border border-white/20 transition-colors duration-300 hover:border-[color:var(--ngp-teal)] hover:bg-[color:var(--ngp-teal)] hover:text-[color:var(--ngp-ink)]">
                <Icon size={18} strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>
        <nav aria-label="Link rapidi" className="lg:col-span-2">
          <p className="eyebrow mb-5 text-[color:var(--ngp-teal)]">Link rapidi</p>
          <ul className="space-y-2.5 text-sm">
            {NAV.map((n) => <li key={n.to}><Link to={n.to} className="link-underline text-white/80 hover:text-white" data-testid={`footer-nav-${n.to.replace("/", "") || "home"}`}>{n.label}</Link></li>)}
          </ul>
        </nav>
        <div className="lg:col-span-3">
          <p className="eyebrow mb-5 text-[color:var(--ngp-teal)]">Sede</p>
          {SEDI.map((s) => <p key={s.city} className="mb-4 text-sm leading-relaxed text-white/80"><span className="font-semibold text-white">{s.city}</span><br />{s.address}<br />{s.cap}</p>)}
        </div>
        <div className="lg:col-span-3">
          <p className="eyebrow mb-5 text-[color:var(--ngp-teal)]">Contatti</p>
          <ul className="space-y-2 text-sm text-white/80">
            <li><a href={CONTACT.phoneMainHref} className="link-underline">{CONTACT.phoneMain}</a></li>
            <li><a href={CONTACT.phoneMobileHref} className="link-underline">{CONTACT.phoneMobile}</a></li>
            {CONTACT.emails.map((m) => <li key={m}><a href={`mailto:${m}`} className="link-underline">{m}</a></li>)}
          </ul>
        </div>
      </div>
      <p aria-hidden="true" className="font-display select-none whitespace-nowrap py-6 text-[17vw] font-semibold uppercase leading-[0.8] tracking-[-0.05em] text-white/[0.06] lg:text-[15.5vw]">Giga Print</p>
      <div className="flex flex-col gap-4 border-t border-white/10 py-6 text-xs text-white/65 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} Tutti i diritti riservati Nuova Gigaprint — P.iva {CONTACT.vat}</p>
        <div className="flex items-center gap-6">
          <Link to="/privacy-cookie" className="link-underline hover:text-white" data-testid="footer-privacy-link">Privacy Policy &amp; Cookie Law</Link>
          <button onClick={() => (window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" }))} className="flex items-center gap-1.5 hover:text-white" data-testid="footer-back-top">
            Torna su <ArrowUp size={14} aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  </footer>
);
